module.exports = __webpack_public_path__ + "img/services-03-landscape.589be28f.jpg";